import React from "react";
import { List, ListItemButton, ListItemIcon, ListItemText, ListSubheader, useTheme, } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useGetAllActivitiesQuery } from "store/slices/apis/documentsSlice";
import { FaRegFolderOpen } from "react-icons/fa6";
import {ReactComponent as FolderOpenIcon} from "assets/PwC_Funct_Icons_FolderOpenAngled_Fill_Black_RGB.svg"


const ActivityListItem = (props) => {
    const { handleRedirect } = props;
    const navigate = useNavigate();
    const theme = useTheme();
    const { projectId, activityId } = useParams();


    const { data: allActivitiesList, isSuccess: allActivitiesIsSuccess } = useGetAllActivitiesQuery({
        projectId: projectId,
        page: 1,
        pageSize: 20,
    });

    return (
        <>
            <List
                sx={{
                    width: '100%',
                    bgcolor: 'background.paper',
                    position: 'relative',
                    overflow: 'auto',
                    maxHeight: 400,
                    '& ul': { padding: 0 },
                }}
                subheader={<li />}
            >
                <li key={`section`}>
                    <ul>
                        <ListSubheader sx={{
                            fontSize: '20px',
                            color: '#252525'
                        }}>{`Activities`}</ListSubheader>
                        {allActivitiesList?.data?.data?.map((item, i) => (
                            <ListItemButton sx={{
                                backgroundColor: item?.id === activityId && '#0000000a'
                            }} onClick={() => handleRedirect(item)}>
                                <ListItemIcon sx={{ minWidth: '30px' }}>
                                     {/* <FaRegFolderOpen style={{
                                        height: '20px', width: '20px', color: `${theme?.customSettings?.themeColor}` */}
                                    <FolderOpenIcon style={{
                                        height: '30px', width: '30px', fill: `${theme?.customSettings?.themeColor}`
                                    }} />
                                </ListItemIcon>
                                <ListItemText primary={`${item?.activityName}`} sx={{
                                    color: "#696969",
                                    '& .MuiTypography-root': {
                                        fontSize: '14px'
                                    }
                                }} />
                            </ListItemButton>
                        ))}
                    </ul>
                </li>
            </List>
        </>
    );
}

export default ActivityListItem;
